import React from "react";
import {Typography, Divider} from '@mui/material';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import WatchLater from "@mui/icons-material/WatchLater";

import NavigationButton from "../NavigationButton";

const styles = {
    sectionHeader: {
        fontSize: '0.7rem'
    },
    divider: {
        my: '0.2rem'
    }
};

export default function SupportMenuSnippet({permissions}) {
    if (!(permissions.canCustomerSupport || permissions.canAdmin || permissions.canTrafficManage || permissions.canQA)) {
        return null;
    }

    return (
        <>
            <Typography variant="overline" sx={styles.sectionHeader}>Support</Typography>

            <NavigationButton displayName="Lookup" toLink="/member-lookup">
                <PersonSearchIcon/>
            </NavigationButton>

            {
                permissions.canCustomerSupport
                &&
                <NavigationButton displayName="Schedule" toLink="/support-schedule">
                    <WatchLater/>
                </NavigationButton>
            }

            <Divider sx={styles.divider}/>
        </>
    );
}